document.addEventListener('DOMContentLoaded', () => {
  const dealersPage = document.querySelector('.dealers-page__container')
  if(dealersPage) {
    const breadcrumbs = document.querySelector('.breadcrumbs')
    breadcrumbs.classList.add('breadcrumbs--dealers')
    const resize = () => {
      breadcrumbs.style.left = `${dealersPage.offsetLeft}px`
    }
    window.addEventListener('resize', resize)
  }
})
